module.exports = __webpack_public_path__ + "img/ru.0cacf46e.svg";